// @spec BCP-STR-040
import { createFileRoute } from '@tanstack/react-router';

import { PlanStatusReport } from '@/features/bcp/components/PlanStatusReport';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/reports/plan-status')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.planStatusReport'),
  }),
  component: PlanStatusReportPage,
});

function PlanStatusReportPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <PlanStatusReport />
      </div>
    </div>
  );
}
